<template>
  <div class="news-and-footer">
    <div class="page_content">
      <h3>Notice of Year-End and New Year Holiday Closure</h3>
      <br>

      <p>
        We would like to express our sincere gratitude for your continued support.<br>
        Please be informed that our office will be closed during the period below.
      </p>

      <p>
      -------------------------------------<br>
      December 27, 2025 (Sat) – January 4, 2026 (Sun)<br>
      -------------------------------------<br>
      </p>

      <p>
       We would also like to inform you of the order deadlines before the holiday closure.<br>
       We apologize for any inconvenience this may cause and kindly ask for your understanding.
      </p>

      <p>
      -------------------------------------<br>
      ■Order Deadline for Cosmetics, Consumables, and Beauty Devices■<br>
      Orders accepted until December 26 (Fri) at 14:00 — final shipment on the same day<br>
      -------------------------------------<br>
      </p>

      <p>
      -------------------------------------<br>
      ■Order Deadline for Lamp Replacements■<br>
     Orders accepted until December 25 (Thu), final shipment on December 26 (Fri)<br>
      ※Please ensure items arrive by December 25.<br>
      　　Items arriving after that date will be shipped after the holiday closure.<br>
      -------------------------------------<br>
      </p>

      <footer2></footer2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news251226',
  props: {
    largescreen: {
      type: Boolean
    }
  },
  components: {
    footer2: () => import('../components/Footer2.vue'),
  },
}
</script>

<style lang="scss" scoped>
.news-and-footer {
  margin-top: 80px;
}

@media (max-width: 600px) {
  .news-and-footer {
    margin-top: 30px;
  }
}
</style>
